import { UserSelectableItem } from "../user/User.types";

export interface LegalEntityWithAddressViewModel {
    name: string;
    address: string;
    city: string;
    zipCode: string;
    country: string;
    id: string;
    referenceNumber: string;
}

export interface LegalEntitySelectorViewModel {
    name: string;
    address: string;
    city: string;
    zipCode: string;
    country: string;
    id: string;
    isActive: boolean;
    users?: Array<UserSelectableItem>;
}

export interface LegalEntityTabCountsViewModel {
    documents: number;
    contracts: number;
    classifications: number;
    audits: number;
    assets: number;
    contacts: number;
}

export interface LegalEntityTemplateStepInfo {
    id: string;
    name: string;
    order: number;
}

export enum LegalEntityOverviewPaperTabEnum {
    Main = 0,
    AllLegalEntityInfo = 1,
}

export enum LegalEntityAuditTabs {
    Contracts = 0,
    Classifications = 1,
    Assets = 2,
    Sharings = 3,
    Audits = 4,
    Documents = 5,
    Contacts = 7,
    Tasks = 8,
}

export enum LegalEntityPlanTabId {
    Contracts = "contracts",
    Classifications = "classifications",
    Assets = "assets",
    Sharings = "sharings",
    Audits = "audits",
    Documents = "documents",
    Contacts = "contacts",
    Tasks = "tasks",
}

// Mirrors Core.DomainModels.StandardLegalEntityType. The types are master data the customer can add to, so a
// type is identified by its id everywhere except the few places that have to recognise a specific standard
// one - those match on this discriminator rather than on the id it happens to have.
export enum StandardLegalEntityType {
    Custom = 0,
    Vendor = 1,
    Customer = 2,
    Authority = 3,
    CollaborationPartner = 4,
    Other = 5,
    DataProcessor = 7,
    SubDataProcessor = 8,
    ServiceProvider = 9,
}

export interface LegalEntityTypeSelectableItem {
    id: string;
    name: string;
    standardType: StandardLegalEntityType;
}

export enum LegalEntityAuditType {
    AuditNotNecessary = 1,
    WrittenConfirmation = 2,
    Declaration = 3,
    AuditStatement = 4,
    SelfAssessment = 5,
    AuditOrAssessment = 7,
    Other = 6,
}

export enum LegalEntityAuditFrequency {
    Quarterly = 1,
    SemiAnnually = 2,
    Annual = 3,
    EveryTwoYears = 4,
    EveryThreeYears = 5,
}
